"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.webInterceptor = void 0;
const local_authentication_1 = __importDefault(require("@shamrock-core/common/authentication/local-authentication"));
const config_1 = require("./config");
const webInterceptor = (config, isTrial = false, deviceId) => {
    var _a, _b, _c;
    if (isTrial) {
        const requester = local_authentication_1.default.getEmail();
        const _d = (_a = config.headers) !== null && _a !== void 0 ? _a : {}, { Authorization, authorization } = _d, rest = __rest(_d, ["Authorization", "authorization"]);
        const url = (config.baseURL &&
            (((_b = config.baseURL) === null || _b === void 0 ? void 0 : _b.charAt(config.baseURL.length - 1)) === ((_c = config.url) === null || _c === void 0 ? void 0 : _c.charAt(0))
                ? config.baseURL + config.url.substring(1, config.url.length)
                : config.baseURL + config.url)) ||
            config.url;
        const body = Object.assign(Object.assign(Object.assign({ headers: rest, url, method: config.method }, (config.params && { params: config.params })), (config.data && { body: config.data })), { requester });
        config = Object.assign(Object.assign({}, config), { headers: {
                'Content-Type': 'application/json',
            }, baseURL: config_1.gatekeeperUrl, url: '', method: 'POST', data: body });
        if (deviceId) {
            config = Object.assign(Object.assign({}, config), { params: Object.assign(Object.assign({}, config.params), { 'device-Id': deviceId }) });
        }
        return config;
    }
    return config;
};
exports.webInterceptor = webInterceptor;
